import { IAirport } from "@/shared/api/aviabooking";
import { Children, FC } from "react";
import { MenuListProps, GroupBase } from "react-select";
import { VariableSizeList } from "react-window";

// optimized select menu list to render large amount of data
const GROUP_HEADER_HEIGHT = 13;
const ITEM_HEIGHT = 60;

export const MenuList: FC<MenuListProps<{
    airport: IAirport;
    value: string;
    label: string;
}, boolean, GroupBase<{
    airport: IAirport;
    value: string;
    label: string;
}>>> = (props) => {
  const { options, getValue } = props;
  const [ value ] = getValue();

  const initialOffset = options.indexOf(value) * ITEM_HEIGHT;

  const children = Children.toArray(props.children);

  const getOptionSize = (option: any) => {
    if (option?.options) {
      return option.options.length * ITEM_HEIGHT + GROUP_HEADER_HEIGHT;
    }
    return ITEM_HEIGHT;
  }

  const getItemSize = (i: number) => {
    return getOptionSize(options?.[i]);
  }

  const totalHeight = options?.reduce((height, option) =>  height + getOptionSize(option), 0);

  const estimatedItemSize = totalHeight / options.length;

  return (
    <VariableSizeList 
      height={Math.min(totalHeight, 300)}
      itemCount={children.length}
      itemSize={getItemSize}
      estimatedItemSize={estimatedItemSize}
      initialScrollOffset={initialOffset}
      width="100%"
      
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </VariableSizeList >
  );
}